import { render, staticRenderFns } from "./sala.vue?vue&type=template&id=16bd5f66&scoped=true&"
import script from "./sala.vue?vue&type=script&lang=ts&"
export * from "./sala.vue?vue&type=script&lang=ts&"
import style0 from "./sala.vue?vue&type=style&index=0&id=16bd5f66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bd5f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
